export default "__VITE_ASSET__fa17dfd8__"